import { BlockType } from '../../types/index.js';
import { ButtonBlock as Component } from './Block.js';
export const RegisteredButtonBlock = (_intl) => ({
    recommendedName: 'Button',
    Component,
    config: {
        type: BlockType.BuildingBlock,
        defaultProps: {
            autoDisabled: true,
            autoLoading: true,
        },
    },
});
//# sourceMappingURL=registered.js.map